<div class="loader">
  <div [hidden]="!loading" data-cy="loader">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  </div>
</div>
